import React from 'react';
import { useCustomSettings } from '../../hooks/use-custom-settings';
import { FooterLinkType, FooterLinkListType } from '../../lib/api';

/* DEFAULTS */
const
  className = 'my-4 mx-8 inline-block text-primary rounded py-1 px-4 on-hover-shadow',
  target = '_blank',
  rel = 'noopener noreferrer'
;

export const FooterLink: React.FC<FooterLinkType> = ({ url: href, label }: FooterLinkType): JSX.Element => {
  return (
    <a
      { ...{ href, rel, target, className }}
    >{label}</a>
  );
};

export const FooterLinkList = (): JSX.Element | null => {
  const { footerLinks } = useCustomSettings();

  if (!footerLinks.length) {
    return null;
  }

  const linksProps = footerLinks as FooterLinkListType;

  return (
    <>
      {
        linksProps
          .sort((a: FooterLinkType, b: FooterLinkType) => a.order - b.order)
          .map((props, index) => <FooterLink key={index} {...props} />)
      }
    </>
  );

};

